import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface DeleteModalProps {
  show: boolean;
  onCloseModal: () => void;
  categoryName: string;
  onConfirmDelete: () => void;
}

const DeleteModal: FC<DeleteModalProps> = ({
  show,
  onCloseModal,
  categoryName,
  onConfirmDelete,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-96 rounded-lg shadow-xl">
        {/* Header */}
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Delete Category</h2>
          <button
            className="text-gray-500 hover:text-gray-700 transition-all"
            onClick={onCloseModal}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        
        {/* Body */}
        <div className="p-4">
          <div className="mb-4">
            <p className="text-gray-700">
              Are you sure you want to delete the category <strong>"{categoryName}"</strong>?
            </p>
            <p className="text-sm text-gray-500 mt-2">
              This action cannot be undone
            </p>
          </div>

          <div className="flex gap-3 justify-center mt-6">
            <button
              type="button"
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
              onClick={onCloseModal}
            >
              Cancel
            </button>
            <ButtonPrimary
              type="button"
              className="bg-red-600 hover:bg-red-700"
              onClick={onConfirmDelete}
            >
              <span>Delete</span>
            </ButtonPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
